// Auth actions
export const AUTH_SAVE = 'AUTH_SAVE';
export const AUTH_CLEAR = 'AUTH_CLEAR';

// Common actions
export const ADMIN_SAVE_VENDORS = 'ADMIN_SAVE_VENDORS';
export const COMMON_ALERT = 'COMMON_ALERT';
export const COMMON_CLOSE_ALERT = 'COMMON_CLOSE_ALERT';
export const COMMON_MODAL_RESIZE = 'COMMON_MODAL_RESIZE';

// Header actions
export const HEADER_TITLE = 'HEADER_TITLE';

// Login actions
// None

// Transfer actions
export const TRANSFERS_SET = 'TRANSFERS_SET';
export const TRANSFERS_INCOMING_SET = 'TRANSFERS_INCOMING_SET';
export const TRANSFERS_PENDING_SET = 'TRANSFERS_PENDING_SET';
export const TRANSFERS_SET_LOCATIONS = 'TRANSFERS_SET_LOCATIONS';
export const TRANSFERS_OPEN_SET = 'TRANSFERS_OPEN_SET';
export const TRANSFERS_CLOSED_SET = 'TRANSFERS_CLOSED_SET';
export const TRANSFERS_CLOSED_SET_LGD = 'TRANSFERS_CLOSED_SET_LGD';
export const TRANSFERS_SET_COUNTS = 'TRANSFERS_SET_COUNTS';
export const TRANSFERS_SET_LGD_COUNTS = 'TRANSFERS_SET_LGD_COUNTS';
export const TRANSFERS_SET_CLOSED_PAGE = 'TRANSFERS_SET_CLOSED_PAGE';

// User (non-global) actions
export const USER_SET = 'USER_SET';

// User (global) actions
export const USER_LOGOUT = 'USER_LOGOUT';